import React from "react";
import UsersRow from "../Tables/Rows/UsersRow";
import UsersPagination from "./UsersPagination";
import { TableLink } from "../Global/Transitions";
import MemberDto from "../../Models/MemberDto";

interface UsersTableBodyProps {
  visible: MemberDto[];
  accounts: any[];
  highestPrivilegeRole?: string;
  allProjects: any[];
  handleRemove: (id: string) => void;
  setEditingUser: (u: Partial<MemberDto>) => void;
  setShowModal: (show: boolean) => void;
  page: number;
  pageSize: number;
  total: number;
  setPage: (page: number) => void;
  addUserDisabled?: boolean;
}

const UsersTableBody: React.FC<UsersTableBodyProps> = ({
  visible,
  accounts,
  highestPrivilegeRole,
  allProjects,
  handleRemove,
  setEditingUser,
  setShowModal,
  page,
  pageSize,
  total,
  setPage,
  addUserDisabled = false,
}) => (
  <tbody>
    {visible.map((m) => {
      const isSelf = m.id === accounts?.[0]?.localAccountId;
      const isUserSuper = m.applicationRole.some(r => (r.userRole ?? "").trim().toLowerCase() === "super user") && highestPrivilegeRole?.trim().toLowerCase() !== "super user";
      const disable = isSelf || isUserSuper;
      return (
        <UsersRow
          key={m.id}
          user={m}
          allprojects={allProjects}
          disabled={disable}
          onRemove={disable ? undefined : () => handleRemove(m.id)}
          highestPrivilegeRole={highestPrivilegeRole}
          onEdit={
            disable
              ? undefined
              : (u) => {
                  setEditingUser(u);
                  setShowModal(true);
                }
          }
        />
      );
    })}
    {visible.length === 0 && (
      <tr>
        <td colSpan={100} className="text-center text-muted">
          No users found
        </td>
      </tr>
    )}
    {Math.ceil(total / pageSize) > 1 && (
      <tr>
        <td colSpan={100} className="p-0">
          <UsersPagination total={total} page={page} pageSize={pageSize} onPageChange={(p) => setPage(p)} />
        </td>
      </tr>
    )}
    <TableLink
      onClick={() => {
        setEditingUser(undefined);
        setShowModal(true);
      }}
      disabled={addUserDisabled}
    >
      New User
    </TableLink>
  </tbody>
);

export default UsersTableBody;
